module.exports = __webpack_public_path__ + "img/hr-heatex-endings.33f9b878.png";